<core-header></core-header>

@if ({ isTop: isTopNav$ | async }; as navigation) {
    <div class="page-wrapper view-wrapper">
        <div class="page-inner site-wrapper">
            <div class="page-content-wrapper wrapper site-content">
                <main
                    #main
                    [ngClass]="{
                        'page-content--no-hero':
                            isTopNavTransparent &&
                            (!heroImagesEnabled || (page && !page.meta.icon) || (post && !post.data.image)),
                    }"
                    class="page-content container-fluid p-0 mobile-padding category-{{ category || 'default' }}"
                    id="main-content"
                    tabindex="-1">
                    @if ((page && page.meta.icon) || (post && post.data.image)) {
                        <div class="header-block">
                            <!-- Hero image for all pages that aren't Home and a Life Moments/Journey pages.
                            Uses just one main image which can be positioned using iconAlign meta for background-position. -->
                            @if (heroImagesEnabled) {
                                <div
                                    [ngStyle]="{
                                        backgroundPosition:
                                            page && page.meta.iconAlign ? page.meta.iconAlign : 'center center',
                                    }"
                                    [style.background-image]="getBackgroundImage() | cdnBackground"
                                    class="header-image">
                                    <div [ngClass]="{ loaded: delayedLoaded }" class="header-overlay"></div>
                                </div>
                            }
                        </div>
                        <core-block-notification-bar></core-block-notification-bar>
                    }
                    <div [class]="containerClass">
                        <router-outlet></router-outlet>
                    </div>
                    @if (notificationsEnabled && !navigation.isTop) {
                        <core-notifications></core-notifications>
                    }
                </main>
                <core-footer></core-footer>
            </div>
            <core-back-to-top></core-back-to-top>
            <core-demo-config-toggle></core-demo-config-toggle>
        </div>
        <span class="page-overlay"></span>
    </div>
    @if (isChatEnabled) {
        <core-block-chat
            [demoMode]="false"
            [botName]="botName()"
            [botAvatar]="botAvatar()"
            [startingMessage]="botStartingMessage()"></core-block-chat>
    }
}
